export default __webpack_public_path__ + "static/media/project-hunt.ca8c00aa.jpg";